<template>
  <div class="fsg-back-cover-promo-area">
    <div class="branding-area">
      <Branding
        v-for="(brand, index) in branding.covers"
        :key="index"
        :brand="brand"
      />
    </div>
  </div>
</template>

<script>
import Branding from "@/components/Projects/Playbooks/Cover/Branding.vue";
import { mapGetters } from 'vuex'

export default {
  name: 'BackCoverFSGPromoArea',
  computed: {
    ...mapGetters("playbook", ["branding"])
  },
  components: {
    Branding
  }
}
</script>

<style lang="scss">
.fsg-back-cover-promo-area {
  height: 100%;

  .branding-area {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

  }
}
</style>